export const getTableExtraScrollPercent = (parentWidth, ownWidth) => {
    if (parentWidth > ownWidth || parentWidth === 0) {
        return "100%";
    } else {
        return `${((ownWidth - parentWidth) / parentWidth) * 100 + 100}%`;
    }
};
